<template>
  <div class="reportDetail_feedbackDetail container">
    <div class="table">
      <div class="handle-box">
        <el-form :model="feedbackData" :label-position="labelPosition" disabled="true" :rules="feedbackRules" ref="feedbackDataForm" label-width="170px">
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.feedbackNo')" prop="feedbackNo">
                <!--单据编号-->
                <el-input class="handle-input" v-model="feedbackData.feedbackNo" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.reportType')" prop="reportType">
                <!--类型-->
                <el-input class="handle-input" v-model="feedbackData.reportTypeI18n" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('common.remarks')" prop="remark">
                <!--备注-->
                <el-input type="textarea" maxlength="1000" autosize class="handle-input" v-model="feedbackData.remark" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20" v-if='feedbackData.suspendReason'>
              <el-form-item :label="$t('storeFeedback.suspendReason')" prop="suspendReason">
                <!--中止原因-->
                <el-input type="textarea" maxlength="1000" autosize class="handle-input" v-model="feedbackData.suspendReason" disabled></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.restaurantsProductsInfo')">
                <!--餐厅&产品基本信息-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.createDate')" prop="createDate">
                <!--餐厅提交日期-->
                <el-input class="handle-input" v-model="feedbackData.createDate" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.creator')" prop="creator">
                <!--填表人-->
                <el-input class="handle-input" v-model="feedbackData.createName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.creatorTelephone')" prop="tel">
                <!--填表人联系电话-->
                <el-input class="handle-input" v-model="feedbackData.tel" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.storeNo')" prop="storeNo">
                <!--餐厅国际编号（7位）-->
                <el-input class="handle-input" v-model="feedbackData.storeNo" v-on:change="changeStore()" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.storeName')" prop="storeName">
                <!--餐厅国际名称-->
                <el-input class="handle-input" v-model="feedbackData.storeName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.city')" prop="city">
                <!--质量问题发生的城市-->
                <el-input class="handle-input" v-model="feedbackData.city" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.materialCode')" prop="materialCode">
                <!--货号-->
                <el-input class="handle-input" v-model="feedbackData.materialCode" v-on:change="changeMaterialCode()" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.dcName')" prop="dcName">
                <!--发货DC-->
                <el-input suffix-icon="el-icon-search" @click.native="showSelDcDialog=true" v-model="feedbackData.dcName" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.materialName')" prop="materialName">
                <!--产品名称-->
                <el-input class="handle-input" v-model="feedbackData.materialName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.supplier')" prop="supplierName">
                <!--供应商-->
                <el-input class="handle-input" v-model="feedbackData.supplierName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.receiveDate')" prop="receiveDate">
                <!--餐厅接货日期-->
                <el-date-picker value-format="yyyy-MM-dd" v-model="feedbackData.receiveDate" type="date" :placeholder="$t('common.selDate')" :disabled="disableEditor"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.productionDate')" prop="productionDate">
                <!--产品生产日期-->
                <el-date-picker value-format="yyyy-MM-dd" v-model="feedbackData.productionDate" type="date" :placeholder="$t('common.selDate')" :disabled="disableEditor"></el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.expirationDate')" prop="expirationDate">
                <!--产品保质期-->
                <el-date-picker value-format="yyyy-MM-dd" v-model="feedbackData.expirationDate" type="date" :disabled="disableEditor"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.lotNumber')" prop="lotNumber">
                <!--生产批号-->
                <el-input class="handle-input" v-model="feedbackData.lotNumber" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.feedbackChannel')" prop="sourceCode">
                <!--反馈渠道-->
                <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="SOURCE_CODE" v-model="feedbackData.sourceCode" :disabled="disableEditor"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.isDirectSale')" prop="isDirectSale">
                <!--是否直营-->
                <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="IS_DIRECT_SALE" v-model="feedbackData.isDirectSale" :disabled="disableEditor"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.relatedParties')" prop="relatedParties">
                <!--相关方涉及-->
                <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="RELATED_PARTIES" v-model="feedbackData.relatedParties" :disabled="disableEditor"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.consumeType')" prop="consumeType">
                <!--消费类型-->
                <ic-select clearable table="TT_FEEDBACK" class="handle-input" field="CONSUME_TYPE" v-model="feedbackData.consumeType" :disabled="disableEditor"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-show="feedbackData.relatedParties == 'other'" :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.relatedPartiesOther')" prop="relatedPartiesOther">
                <!--相关方涉及其它-->
                <el-input class="handle-input" v-model="feedbackData.relatedPartiesOther" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <!-- 质量反馈中心备注 -->
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.fcRemarks')">
                <el-input type="textarea" autosize class="handle-input" v-model="feedbackData.fcRemarks" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 最终责任方 -->
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item label="最终责任方">
                 <IcSelect table='TT_FEEDBACK_REPORT' field='FINAL_RESPONSIBLE_PARTY' v-model="feedbackData.finalResponsibleParty" disabled></IcSelect>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="handle-box">
        <el-form :model="feedbackComplaintData" :label-position="labelPosition" :rules="feedbackComplaintRules" ref="feedbackComplaintDataForm" label-width="170px">
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.complaintInfo')">
                <!--投诉基本信息-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="7">
              <el-form-item label="外包装数量" prop="outerPackNum">
                <el-input class="handle-input unit__uom" v-model="feedbackComplaintData.outerPackNum" :disabled="disableEditor">
                  <template v-if="feedbackComplaintData.outerPackSpec" slot="append">{{feedbackComplaintData.outerPackSpec}}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="内包装数量" prop="innerPackNum" label-width="150px">
                <el-input class="handle-input unit__uom" v-model="feedbackComplaintData.innerPackNum" :disabled="disableEditor">
                  <template v-if="feedbackComplaintData.innerPackSpec" slot="append">{{feedbackComplaintData.innerPackSpec}}</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="散货数量" prop="bulkNum" label-width="140px">
                <el-input class="handle-input unit__uom" v-model="feedbackComplaintData.bulkNum" :disabled="disableEditor">
                  <template v-if="feedbackComplaintData.bulkUnit" slot="append">{{feedbackComplaintData.bulkUnit}}</template>
                </el-input>
              </el-form-item>
            </el-col>
<!--            <el-col :span="10">-->
<!--              <el-form-item label="外包装单位" prop="outerPackUnit">-->
<!--                <el-input v-model="feedbackComplaintData.outerPackSpec" :disabled="true"></el-input>-->
<!--              </el-form-item>-->
<!--            </el-col>-->
          </el-row>
<!--          <el-row :gutter="16">-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="内包装数量" prop="innerPackNum">-->
<!--              <el-input class="handle-input" v-model="feedbackComplaintData.innerPackNum" :disabled="disableEditor"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="内包装单位" prop="innerPackUnit">-->
<!--              <el-input v-model="feedbackComplaintData.innerPackSpec" :disabled="true"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--        <el-row :gutter="16">-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="散货数量" prop="bulkNum">-->
<!--              <el-input class="handle-input" v-model="feedbackComplaintData.bulkNum" :disabled="disableEditor"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="10">-->
<!--            <el-form-item label="散货单位" prop="bulkUnit">-->
<!--              <el-input v-model="feedbackComplaintData.bulkUnit" :disabled="true"></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->

          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.source')" prop="source">
                <!--选择问题反馈的来源-->
                <ic-select clearable table="TT_FEEDBACK_COMPLAINT" class="handle-input" field="SOURCE" v-model="feedbackComplaintData.source" :disabled="disableEditor"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.productStatus')" prop="productStatus">
                <!--问题产品状态-->
                <ic-select clearable table="TT_FEEDBACK_COMPLAINT" class="handle-input" field="PRODUCT_STATUS" v-model="feedbackComplaintData.productStatus" :disabled="disableEditor"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.ccStore')" prop="cc" :rules="isStore ? feedbackComplaintRules.cc : []">
                <!--CC抄送人（门店）-->
                <el-input class="handle-input" v-model="feedbackComplaintData.cc" @blur='feedbackComplaintData.cc=feedbackComplaintData.cc.replace(/\s+/g,"")' :disabled="disableEditor"></el-input>
                <div class='ccTip'>质量反馈单需同时抄送所属的OC、OM、QSC/EHSS经理<br />若有多个邮箱，请用逗号或分号区分</div>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.haveCompensated')" prop="haveCompensated">
                <!--是否发生用餐者赔偿-->
                <ic-select clearable table="TT_FEEDBACK_COMPLAINT" class="handle-input" field="HAVE_COMPENSATED" v-model="feedbackComplaintData.haveCompensated" :disabled="disableEditor"></ic-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.compensateInfo')" prop="compensateInfo">
                <!--赔偿内容-->
                <el-input type="textarea" autosize class="handle-input" v-model="feedbackComplaintData.compensateInfo" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('common.remarks')" prop="remark">
                <!--备注-->
                <el-input type="textarea" autosize class="handle-input" v-model="feedbackComplaintData.remark" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider content-position="left"></el-divider>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.describeProblem')">
                <!--请详细描述发生问题-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.description')" prop="description">
                <!--描述-->
                <el-input type="textarea" autosize v-model="feedbackComplaintData.description" placeholder="" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('common.attachment')">
                <!--附件-->
                <el-table :data="detailDocfileList" border highlight-current-row class="table">
                  <el-table-column sortable prop="documentName" :label="$t('common.file')" min-width="130px">
                    <!--文件-->
                    <template slot-scope="scope">
                      <el-link type="primary" @click.native="downloadFile(scope.row)">{{scope.row.documentName}} </el-link>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form-item>
            </el-col>
          </el-row>
          <el-divider content-position="left"></el-divider>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :required="reportType=='STORE'" :label="$t('storeFeedback.boxPhoto')">
                <!--外箱照片（含生产日期）-->
                <el-upload disabled list-type="picture-card" action="upload" :file-list="foreignPic">
                  <div slot="file" slot-scope="{file}" style="height: 100%">
                    <img width='100%' height='100%' :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handleBoxPhotoPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                        <i class="el-icon-download"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="boxPhotoDialogVisible" class="enlargePhoto">
                  <img width="100%" :src="boxPhotoImageUrl" alt="">
                </el-dialog>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.problemProductPhoto')" prop="problemProductPhoto">
                <!--问题产品照片-->
                <el-upload disabled list-type="picture-card" action="upload" :file-list="questionPic">
                  <div slot="file" slot-scope="{file}" style="height: 100%">
                    <img width='100%' height='100%' :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handleProblemProductPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                        <i class="el-icon-download"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="problemProductDialogVisible" class="enlargePhoto">
                  <img width="100%" :src="problemProductImageUrl" alt="">
                </el-dialog>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.otherPhotos')" prop="otherPhotos">
                <!--其他照片-->
                <el-upload disabled list-type="picture-card" action="upload" :file-list="otherPic">
                  <div slot="file" slot-scope="{file}" style="height: 100%">
                    <img width='100%' height='100%' :src="file.url" alt="">
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-preview" @click="handleOtherPhotosPreview(file)">
                        <i class="el-icon-zoom-in"></i>
                      </span>
                      <span v-if="file.tmDocumentId" class="el-upload-list__item-delete" @click="downloadFile(file)">
                        <i class="el-icon-download"></i>
                      </span>
                    </span>
                  </div>
                </el-upload>
                <el-dialog :visible.sync="otherPhotosDialogVisible" class="enlargePhoto">
                  <img width="100%" :src="otherPhotosImageUrl" alt="">
                </el-dialog>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.photosDescription')" prop="photosDescription">
                <!--照片要求说明-->
                <el-input type="textarea" autosize v-html="feedbackComplaintData.photosDescription" placeholder="" :disabled="disableEditor"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <!-- 2497  调查报告（门店） - 查看反馈单详情 门店不应该看到初检信息 -->
      <div v-if="showFirstCheck && !isStore">
        <el-form :model="feedbackFirstCheckData" :label-position="labelPosition" :rules="feedbackFirstCheckRules" ref="feedbackFirstCheckDataForm" label-width="170px">
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.problemFirstCheckInfo')">
                <!--问题初检信息-->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.complaintType1')" prop="type1">
                <!--投诉分类1-->
                <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="TYPE1" v-model="feedbackFirstCheckData.type1" v-on:change="changeType1()" :disabled="disableEditorFirstCheck"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.complaintType2')" prop="type2">
                <!--投诉分类2-->
                <el-select v-model="feedbackFirstCheckData.type2" :disabled="disableEditorFirstCheck">
                  <el-option :key="index" v-for="(item,index) in type2List" :label="item.chineseValue" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.complaintType3')" prop="type3">
                <!--投诉分类3-->
                <el-select v-model="feedbackFirstCheckData.type3" :disabled="disableEditorFirstCheck">
                  <el-option :key="index" v-for="(item,index) in type3List" :label="item.chineseValue" :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.problemLevel')" prop="problemLevel">
                <!--问题等级-->
                <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="PROBLEM_LEVEL" v-model="feedbackFirstCheckData.problemLevel" @change="changeProblemLevel" :disabled="disableEditorFirstCheck"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.deadline')" prop="deadlineValue">
                <!--要求完成时间-->
                <el-input class="handle-input" v-model="feedbackFirstCheckData.deadline +'小时'" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.isRepeat')" prop="isRepeat">
                <!--是否重复-->
                <el-input class="handle-input" v-model="feedbackFirstCheckData.isRepeat" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.isLto')" prop="isLto">
                <!--是否LTO-->
                <el-select v-model="feedbackFirstCheckData.isLto" placeholder="请选择" :disabled="disableEditorFirstCheck">
                  <el-option v-for="item in isLtoOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.relateType')" prop="relateType">
                <!--相关方判断-->
                <ic-select clearable table="TT_FEEDBACK_FIRST_CHECK" class="handle-input" field="RELATE_TYPE" v-model="feedbackFirstCheckData.relateType" v-on:change="changeRelateType()" :disabled="disableEditorFirstCheck"></ic-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item :label="$t('storeFeedback.dcName')" prop="firstCheckDcName">
                <!--发货DC-->
                <el-input suffix-icon="el-icon-search" @click.native="showFirstCheckSelDcDialog=true" v-model="feedbackFirstCheckData.firstCheckDcName" :disabled="disableEditorFirstCheck"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.cc')" prop="cc">
                <!--CC-->
                <el-input class="handle-input" v-model="feedbackFirstCheckData.cc" :disabled="disableEditorFirstCheck"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="20">
              <el-form-item :label="$t('storeFeedback.mailContent')" prop="mailContent">
                <!--邮件内容-->
                <el-input type="textarea" autosize v-model="feedbackFirstCheckData.mailContent" placeholder="" :disabled="disableEditorFirstCheck"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import storeFeedbackApi from "@/api/storeFeedback/storeFeedback";
import IcSelect from "@/components/common/icSelect";
import { fileService } from "@/api/common/file-utils";
import PickupUser from "@/components/common/pickupUser";
import SelDc from '../base-data/dc-sel-page'
import { Message } from "element-ui";
import { inputChoiceService } from "@/api/common/input-choice";
import commonFun from "@/utils/commonFun";

let changeValidator = (rule, value, callback) => {
  if (value == "") {
    callback(new Error());
  } else {
    callback();
  }
};

export default {
  name: "report-detail_feedback-detail",
  components: { IcSelect, PickupUser, SelDc },
  props: {
    value: Object
  },
  inject: ['reload'],
  data() {
    return {
      detailDocfileList: [],
      foreignPic: [],
      questionPic: [],
      otherPic: [],
      labelPosition: 'right',
      isLtoOptions: [{
        value: 'Y',
        label: this.$t('common.yes')
      }, {
        value: 'N',
        label: this.$t('common.no')
      }],
      type2List: [],
      type3List: [],
      ttFeedbackId: null,
      showSelDcDialog: false,
      showFirstCheckSelDcDialog: false,
      showFirstCheck: true,
      disableEditor: true,
      disableEditorFirstCheck: true,
      saveBtnShow: false,
      submitBtnShow: false,
      returnBtnShow: false,
      isStore: false,
      isFBC: false,
      isMCD: false,
      isSUP: false,
      boxPhotoImageUrl: '',
      problemProductImageUrl: '',
      otherPhotosImageUrl: '',
      boxPhotoDialogVisible: false,
      problemProductDialogVisible: false,
      otherPhotosDialogVisible: false,
      feedbackRules: {
        tel: [
          //填表人联系电话不能为空
          { required: true, message: this.$t('storeFeedback.creatorTelephone') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        storeNo: [
          //餐厅国际编号（7位）不能为空
          { required: true, message: this.$t('storeFeedback.storeNo') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        storeName: [
          //餐厅国际编号（7位）不存在
          { required: true, message: this.$t('storeFeedback.storeNo') + this.$t('common.doesNotExist'), trigger: 'blur' },
          { required: true, message: this.$t('storeFeedback.storeNo') + this.$t('common.doesNotExist'), validator: changeValidator, trigger: 'change' }
        ],
        dcName: [
          //发货DC不能为空
          { required: true, message: this.$t('storeFeedback.dcName') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        materialCode: [
          //货号不能为空
          { required: true, message: this.$t('storeFeedback.materialCode') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        materialName: [
          //货号不存在
          { required: true, message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), trigger: 'blur' },
          { required: true, message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), validator: changeValidator, trigger: 'change' }
        ],
        supplierName: [
          //货号不存在
          { required: true, message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), trigger: 'blur' },
          { required: true, message: this.$t('storeFeedback.materialCode') + this.$t('common.doesNotExist'), validator: changeValidator, trigger: 'change' }
        ],
        receiveDate: [
          //请选择餐厅接货日期
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.receiveDate'), trigger: 'blur' }
        ],
        productionDate: [
          //请选择产品生产日期
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.productionDate'), trigger: 'blur' }
        ],
        feedbackChannel: [
          //请选择反馈渠道
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.feedbackChannel'), trigger: 'change' }
        ],
        isDirectSale: [
          //请选择是否直营
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.isDirectSale'), trigger: 'blur' },
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.isDirectSale'), validator: changeValidator, trigger: 'change' }
        ],
        consumeType: [
          //请选择消费类型
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.consumeType'), trigger: 'blur' },
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.consumeType'), validator: changeValidator, trigger: 'change' }
        ]
      },
      feedbackComplaintRules: {
        cc: [{ required: true, message: '不能为空', trigger: 'blur' },],
        productNum: [
          //问题产品数量不能为空
          { required: true, message: this.$t('storeFeedback.productNum') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ],
        productUnit: [
          //请选择问题产品数量单位
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.productUnit'), trigger: 'change' }
        ],
        // source: [
        //   //请选择问题反馈的来源
        //   { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.source'), trigger: 'change' }
        // ],
        productStatus: [
          //请选择问题产品状态
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.productStatus'), trigger: 'change' }
        ],
        haveCompensated: [
          //请选择是否发生用餐者赔偿
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.haveCompensated'), trigger: 'change' }
        ],
        description: [
          //描述不能为空
          { required: true, message: this.$t('storeFeedback.description') + this.$t('common.canNotBeEmpty'), trigger: 'blur' }
        ]
      },
      feedbackFirstCheckRules: {
        type1: [
          //请选择投诉分类1
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.complaintType1'), trigger: 'change' }
        ],
        type2: [
          //请选择投诉分类2
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.complaintType2'), trigger: 'change' }
        ],
        problemLevel: [
          //请选择问题等级
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.problemLevel'), trigger: 'change' }
        ],
        isLto: [
          //请选择是否LTO
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.isLto'), trigger: 'change' }
        ],
        relateType: [
          //请选择相关方判断
          { required: true, message: this.$t('common.pleaseSelect') + this.$t('storeFeedback.relateType'), trigger: 'change' }
        ],
        mailContent: [
          //邮件内容不能为空
          { required: true, message: this.$t('storeFeedback.description') + this.$t('common.mailContent'), trigger: 'blur' }
        ],
      },
    };
  },
  created() {
    let roles = JSON.parse(localStorage.getItem("ms_roles"));
    let emplFlag = localStorage.getItem('ms_emplFlag');
    for (let i = 0, len = roles.length; i < len; i++) {
      if (roles[i] == 'SF_STORE_BASIC') {//门店
        this.isStore = true;
      }
      if (roles[i] == 'SF_FBC_BASIC') {//反馈中心
        this.isFBC = true;
      }
      if (roles[i] == 'SF_MCD_BASIC') {//麦当劳
        this.isMCD = true;
      }
    }
    if (emplFlag == "SUP") {//供应商
      this.isSUP = true;
    }
    this.getType2Option();
    // this.storeFeedbackPageInitM();
  },
  computed: {
    feedbackData() {
      let _this = this;
      this.getType2Option();
      this.getType3Option();

      this.detailDocfileList = this.value.detailDoc
      let foreignPic = this.value.foreignPic
      if (foreignPic) {
        var temp = foreignPic.map(function (item, index) {
          let obj = {
            url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
            documentName: item["documentName"],
            downloadType: item["downloadType"],
            tmDocumentId: item["tmDocumentId"]
          };
          return obj;
        });
        this.foreignPic = temp
      }


      let questionPic = this.value.questionPic
      if (questionPic) {
        var temp2 = questionPic.map(function (item, index) {
          let obj = {
            url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
            documentName: item["documentName"],
            downloadType: item["downloadType"],
            tmDocumentId: item["tmDocumentId"]
          };
          return obj;
        });
        this.questionPic = temp2
      }

      let otherPic = this.value.otherPic
      if (otherPic) {
        var temp3 = otherPic.map(function (item, index) {
          let obj = {
            url: '/adminconsole/file/downloadByKey?key=' + item["documentKey"],
            documentName: item["documentName"],
            downloadType: item["downloadType"],
            tmDocumentId: item["tmDocumentId"]
          };
          return obj;
        });
        this.otherPic = temp3
      }
      let reportType = this.value.feedback.reportType;
      _this.feedbackComplaintData = this.value.feedbackComplaint == null ? { compensateInfo: null } : this.value.feedbackComplaint;
      if (reportType == 'FBC') {
        _this.feedbackComplaintData.photosDescription = "* 照片提供：请餐厅随本反馈单提供" +
          "<br\/>*【外箱照片(显示外箱状况、产品名称、生产日期或箱号、保质期信息、供应商信息、需清晰)，若无则提供产品台账】； " +
          "<br\/>*问题产品照片（请留存样品）";
      } else {
        _this.feedbackComplaintData.photosDescription = "* 照片提供：请餐厅随本反馈单提供" +
          "<br\/>*<font>【外箱照片(显示外箱状况、产品名称、生产日期或箱号、保质期信息、供应商信息、需清晰)，若无则提供产品台账】</font>" +
          "<br\/>*有问题的产品请务必留存;";
      }

      return this.value.feedback;
    },
    feedbackFirstCheckData() {
      let feedbackFirstCheck = this.value.feedbackFirstCheck;
      feedbackFirstCheck.mailA = this.value.mailA;
      feedbackFirstCheck.mailB = this.value.mailB;
      feedbackFirstCheck.mailC = this.value.mailC;
      return feedbackFirstCheck;
    },
    feedbackComplaintData() {
      return this.value.feedbackComplaint;
    }
  },
  methods: {
    storeFeedbackPageInitM() {
      let _this = this;
      _this.feedbackData = this.value.feedback;
      _this.feedbackComplaintData = this.value.feedbackComplaint == null ? {} : this.value.feedbackComplaint;
      _this.feedbackComplaintData.photosDescription = "* 照片提供：请餐厅随本反馈单提供" +
        "\n*【外箱照片(显示外箱状况、产品名称、生产日期或箱号、保质期信息、供应商信息、需清晰)，若无则提供产品台账】" +
        "\n*有问题的产品请务必留存;"
      _this.feedbackFirstCheckData = this.value.feedbackFirstCheck == null ? {} : this.value.feedbackFirstCheck;
      _this.feedbackFirstCheckData.mailA = this.value.mailA;
      _this.feedbackFirstCheckData.mailB = this.value.mailB;
      _this.feedbackFirstCheckData.mailC = this.value.mailC;

      if (_this.feedbackFirstCheckData.deadline != null) {
        _this.feedbackFirstCheckData.deadlineValue = _this.feedbackFirstCheckData.deadline + this.$t('storeFeedback.hours');
      }
      this.getType2Option();
    },
    historyBack: function () {
      this.$router.go(-1);
    },
    selectDcMethod: function (dcList) {
      this.feedbackData.dcName = dcList[0].dcName;
      this.feedbackData.tmDcId = dcList[0].tmDcId;
      this.showSelDcDialog = false;
    },
    selectFirstCheckDcMethod: function (dcList) {
      this.feedbackFirstCheckData.firstCheckDcName = dcList[0].dcName;
      this.feedbackFirstCheckData.firstCheckDcId = dcList[0].tmDcId;
      this.showFirstCheckSelDcDialog = false;
    },
    //文件下载
    downloadFile: function (row) {
      fileService.downloadFile(row).then((res) => { })
    },
    getType2Option: function () {
      let _this = this;
      if (_this.feedbackFirstCheckData.type1 != null) {
        let mapObj = {};
        mapObj["TT_FEEDBACK_FIRST_CHECK:TYPE2"] = "TT_FEEDBACK_FIRST_CHECK:TYPE2";
        let type2TmpList = {};
        inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
          let type2List = res["TT_FEEDBACK_FIRST_CHECK:TYPE2"];
          type2List.some((ic, i) => {
            if (ic.restrictFieldValue1 != _this.feedbackFirstCheckData.type1) {
              type2List.splice(i, 1);
            }
          });
          _this.type2List = type2List;
        });
      }
    },
    getType3Option: function () {
      let _this = this;
      if (_this.feedbackFirstCheckData.type2 != null) {
        let mapObj = {};
        mapObj["TT_FEEDBACK_FIRST_CHECK:TYPE3"] = "TT_FEEDBACK_FIRST_CHECK:TYPE3";
        let type3TmpList = {};
        inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
          let type3List = res["TT_FEEDBACK_FIRST_CHECK:TYPE3"];
          type3List.some((ic, i) => {
            if (ic.restrictFieldValue1 != _this.feedbackFirstCheckData.type2) {
              type3List.splice(i, 1);
            }
          });
          _this.type3List = type3List;
        });
      }
    },
    handleBoxPhotoPreview(file) {
      this.boxPhotoImageUrl = file.url;
      this.boxPhotoDialogVisible = true;
    },
    handleProblemProductPreview(file) {
      this.problemProductImageUrl = file.url;
      this.problemProductDialogVisible = true;
    },
    handleOtherPhotosPreview(file) {
      this.otherPhotosImageUrl = file.url;
      this.otherPhotosDialogVisible = true;
    }
  },
};
</script>
<style scoped lang="scss">
.topform {
  margin-top: 20px;
}

/deep/ .unit__uom .el-input-group__append {
  padding: 0 6px !important;
}
</style>
<style lang="scss">
.reportDetail_feedbackDetail {
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-upload--picture-card {
    display: none;
  }
  .ccTip {
    font-size: 12px;
    color: #f56c6c;
  }
}
.enlargePhoto {
  .el-dialog {
    width: 90%;
    margin-top: 10px;
  }
}
</style>

